import { render, staticRenderFns } from "./RideHailingEditVersion.vue?vue&type=template&id=44d8bee8&"
import script from "./RideHailingEditVersion.vue?vue&type=script&lang=js&"
export * from "./RideHailingEditVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports